import { WorkspaceMessageFrequencyLimitsRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/settings/actions/message_frequency_limits',
)({
  component: WorkspaceMessageFrequencyLimitsRoute,
});
